/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createSinh } from '../../factoriesAny.js';
export var sinhDependencies = {
  typedDependencies,
  createSinh
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesSinh.generated.js
// module id = TOnH
// module chunks = 3